import {Component as $pyxeo$Component} from "react";
import $pyxeo$macrostrathyper from "@macrostrat/hyper";
import $pyxeo$classnames from "classnames";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;




var $aVUB5 = parcelRequire("aVUB5");

var $gziYm = parcelRequire("gziYm");
const $a50a0bf8b84c6299$export$55560e413af7340b = ({ facies: facies })=>(0, $pyxeo$macrostrathyper)("div.header", [
        (0, $pyxeo$macrostrathyper)("p.name", {
            style: {
                marginRight: 20,
                textAlign: "left"
            }
        }, facies.name),
        (0, $pyxeo$macrostrathyper)((0, $gziYm.FaciesSwatch), {
            facies: facies
        })
    ]);
class $a50a0bf8b84c6299$export$addc126cc23af936 extends (0, $pyxeo$Component) {
    constructor(props){
        super(props);
        this.renderEach = this.renderEach.bind(this);
    }
    static #_ = this.contextType = (0, $aVUB5.FaciesContext);
    static #_2 = this.defaultProps = {
        selected: null,
        isEditable: false
    };
    renderEach(d) {
        let onClick = null;
        const style = {};
        if (this.props.onClick != null) {
            onClick = ()=>this.props.onClick(d);
            style.cursor = "pointer";
        }
        const { selected: selected } = this.props;
        if (selected === d.id) {
            style.backgroundColor = d.color;
            style.color = "white";
        }
        const className = (0, $pyxeo$classnames)({
            selected: selected === d.id
        });
        return (0, $pyxeo$macrostrathyper)("div.facies.bp3-card.bp3-elevation-0", {
            key: d.id,
            onClick: onClick,
            style: style,
            className: className
        }, (0, $pyxeo$macrostrathyper)($a50a0bf8b84c6299$export$55560e413af7340b, {
            facies: d
        }));
    }
    render() {
        const { facies: facies } = this.context;
        return (0, $pyxeo$macrostrathyper)("div.facies-description-small", [
            (0, $pyxeo$macrostrathyper)("h5", "Facies"),
            (0, $pyxeo$macrostrathyper)("div", facies.map(this.renderEach))
        ]);
    }
}


//# sourceMappingURL=description.83398dbc.js.map
